const LS_DISMISS = 'mingo_visa_banner_dismiss_day';

export function getVisaBannerDismissDay() {
  if (typeof window === 'undefined') return '';
  return window.localStorage.getItem(LS_DISMISS) || '';
}

export function setVisaBannerDismissDay(dayKey) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LS_DISMISS, dayKey);
}
